import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiAppFetch } from '../utils/apiFetch';
import { isWeekSettlement, weekRangeFromOrder } from '../utils/weekBillHelpers';
import '../Ledger.css';

function Ledger() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await apiAppFetch('ledger', {
        method: 'POST',
        body: JSON.stringify({}),
      });

      if (response.status === 401) {
        navigate('/login', { replace: true });
        return;
      }

      if (!response.ok) {
        return;
      }

      const dataa = await response.json();
      setData(Array.isArray(dataa) ? dataa : []);
    } catch (error) {
      // fetch failed silently
    }
  };

  const closingBalance =
    data.length > 0 ? Number(data[data.length - 1].mainAmount) : 0;

  const tableToCSV = () => {
    const csvData = [];
    const rows = document.getElementsByTagName('tr');

    for (let i = 0; i < rows.length; i++) {
      const cols = rows[i].querySelectorAll('td,th');
      const csvRow = [];
      for (let j = 0; j < cols.length; j++) {
        if (cols[j].innerHTML.includes('open')) continue;
        csvRow.push(cols[j].innerHTML);
      }
      csvData.push(csvRow.join(','));
    }
    downloadCSVFile(csvData.join('\n'));
  };

  const downloadCSVFile = (csvData) => {
    const CSVFile = new Blob([csvData], { type: 'text/csv' });
    const tempLink = document.createElement('a');
    tempLink.download = 'ledger.csv';
    const url = window.URL.createObjectURL(CSVFile);
    tempLink.href = url;
    tempLink.style.display = 'none';
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  };

  const hasTransactions = data.length > 0;

  const openWeekBill = (order) => {
    const range = weekRangeFromOrder(order);
    const params = new URLSearchParams({
      s: range.start,
      e: range.end,
    });
    const path = `/week-bill?${params.toString()}`;
    if (window.ReactNativeWebView) {
      navigate(path);
      return;
    }
    window.open(path, '_blank', 'noopener,noreferrer');
  };

  return (
    <main id="main" className="main ledger-page">
      <div className="pagetitle" style={{ marginBottom: '1rem', display: 'none' }}>
        <div style={{ float: 'left' }}>
          <h1>Ledger</h1>
        </div>
        <div style={{ float: 'right' }} className="noprint">
          <img src="pdf_icon.png" onClick={() => window.print()} style={{ height: '30px', cursor: 'pointer' }} alt="PDF" />
          <img src="excel_icon.png" onClick={tableToCSV} style={{ height: '30px', cursor: 'pointer' }} alt="Excel" />
        </div>
        <div style={{ clear: 'both' }}></div>
      </div>
      <section className="section ledger-section">
        <div className="row">
          <div className="col-lg-12">
            <ul className="ledger-list">
              <li className="ledger-item ledger-item--closing">
                <div className="ledger-row ledger-row--single">
                  <span className="ledger-label">Closing Balance</span>
                  <span className="ledger-value ledger-value--balance">
                    {closingBalance.toFixed(2)}
                  </span>
                </div>
              </li>

              {hasTransactions ? (
                data.map((order) => {
                  const weekSettlement = isWeekSettlement(order);
                  return (
                  <li
                    key={order.transactionId}
                    className={`ledger-item${weekSettlement ? ' ledger-item--week-pl' : ''}`}
                    onClick={weekSettlement ? () => openWeekBill(order) : undefined}
                    onKeyDown={weekSettlement ? (event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        openWeekBill(order);
                      }
                    } : undefined}
                    role={weekSettlement ? 'button' : undefined}
                    tabIndex={weekSettlement ? 0 : undefined}
                  >
                    <div className="ledger-header">
                      <span className="ledger-remark">
                        {order.manualRemark?.trim() || order.autoRemark}
                      </span>
                      <span className="ledger-date">
                        {new Date(order.dateTime).toLocaleDateString('en-GB')}
                      </span>
                    </div>
                    <div className="ledger-body">
                      <div className="ledger-col">
                        <span className="ledger-field-label">Amount</span>
                        <p
                          className={`ledger-amount ${
                            order.transactionType == 1
                              ? 'ledger-amount--credit'
                              : 'ledger-amount--debit'
                          }`}
                        >
                          {order.transactionType == 1
                            ? Number(order.transactionAmount).toFixed(2)
                            : `-${Number(order.transactionAmount).toFixed(2)}`}
                        </p>
                      </div>
                      <div className="ledger-col ledger-col--right">
                        <span className="ledger-field-label">Balance</span>
                        <p className="ledger-balance">
                          {Number(order.mainAmount).toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </li>
                );
                })
              ) : (
                <li className="ledger-empty">No ledger entries yet.</li>
              )}
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Ledger;
